
export default {
	'DATE_FORMAT': 'DD/MM/YYYY HH:mm',
	'DATE_FORMAT2': 'YYYY-MM-DD',
	'DATE_TIME_FORMAT': 'DD/MM/YYYY HH:mm',
	'DATE_TIME_FORMAT_ZH':'YYYY年MM月DD日 HH:mm',
	'DATE_TIME_FORMAT_English': 'DD MMMM YYYY',
	'DATE_TIME_FORMAT_English_Time': 'HH:mm',
	'SHORT_DATE_FORMAT_PATTERNKEY': 'DD MMM',
	'DATE_RANGE_DISPLAY_FORMAT_PATTERNKEY': 'DD MMM YYYY',
	'DATETIME_FULL_DISPLAY_FORMAT_PATTERNKEY': 'DD/MM/YYYY HH:mm',
	'DATETIME_RANGE_DISPLAY_FORMAT_PATTERNKEY': 'DD MMM YYYY HH:mm',
	'ABSOLUTE_PERCENTAGE_ROUNDUPZERO': 'N',
	'T': 'DD MMM YYYY',
	'H': 'DD MMM YYYY HH:mm',
	'DATE_FORMAT_PATTERNKEY': 'DD MMM YYYY',
	'DATETIME_FORMAT_PATTERNKEY': 'DD MMM YYYY HH:mm',
	'GOAL_SUMMARY_DATE_FORMAT_PATTERNKEY': 'DD/MM/YYYY',
	'BULLETINBOARD_LASTLOGIN_DATETIME_FORMAT_PATTERNKEY': 'MM/DD/YYYY HH:mm:ss a',
	'BULLETINBOARD_MSG_DATETIME_FORMAT_PATTERNKEY': 'MMM DD HH:mm:ssa',
	'DATA_INTERVAL': 'MMM DD',
	'DATA_INTERVAL_D': 'MMM DD',
	'DATA_INTERVAL_DTD': 'MMM DD HH:mm',
	'DATE_FORMAT_DTD': 'YYYYMMDD',
	'DATE_FORMAT_DTZ': 'YYYY-MM-DDTHH:mm:ss.SSS',
	'DATE_FORMAT_DTZ_TIMESTAMP': 'YYYY-MM-DDTHH:mm:ss+0000'
};
